import { useNavigate } from 'react-router'
import { useAuth } from '../lib/auth.js'
import { Button, Heading } from '../ui/index.js'
import { NotificationBell } from './notifications/NotificationBell.js'

export function Topbar({
  title,
  eyebrow,
  actions,
}: {
  title: string
  eyebrow?: string
  actions?: React.ReactNode
}) {
  const { user, signOut } = useAuth()
  const navigate = useNavigate()

  return (
    <header className="app-topbar">
      <div style={{ minWidth: 0 }}>
        {eyebrow !== undefined ? <div className="card-label">{eyebrow}</div> : null}
        <Heading type="h2">{title}</Heading>
      </div>
      <div className="row-actions">
        <NotificationBell />
        {actions}
        {user !== null ? (
          <span style={{ fontSize: 13, color: 'var(--fg-muted)' }}>{user.organisation.name}</span>
        ) : null}
        <Button
          kind="tertiary"
          size="small"
          onClick={async () => {
            await signOut()
            navigate('/login', { replace: true })
          }}
        >
          Sign out
        </Button>
      </div>
    </header>
  )
}
